import { render, staticRenderFns } from "./Evento_liga_live.vue?vue&type=template&id=5984017b&scoped=true"
import script from "./Evento_liga_live.vue?vue&type=script&lang=js"
export * from "./Evento_liga_live.vue?vue&type=script&lang=js"
import style0 from "./Evento_liga_live.vue?vue&type=style&index=0&id=5984017b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5984017b",
  null
  
)

export default component.exports